import {
  GET_PURCHASE_ORDERS,
  CREATE_VEHICLE_TRACKING,
  GET_TARGET_VS_ACTUAL_FOR_CONFIG,
  GET_TIMELINE,
  GET_PO_LIST,
  GET_PO_ITEMS,
  MOVE_TO_NEXT_STAGE,
  CREATE_UPCOMING_WORKFLOW_STAGE_REQUEST,
  GET_STAGE_DATA,
  GET_VEHICLE_TRAKING_REPORT_DATA,
  GET_VEHICLE_TRACKING_DETAILS,
  GET_BARCODE,
  GET_BUSINESS_PARTNER_WITH_OPEN_PO_DROPDOWN_OPTIONS,
  GET_ASSIGNED_STAGES,
  GET_WORKFLOWS,
  GET_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING,
  CLEAR_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING,
  GET_TARGET_VS_ACTUAL_CONFIG_FOR_WORKFLOW_STAGE,
  CREATE_TARGET_VS_ACTUAL_LOGS,
  GET_VEHICLE_TRACKING_REPORT_LIST,
  GET_VEHICLE_TRACKING_LIST,
  GET_NEXT_AVAILABLE_WORKFLOW_STAGES,
  SKIP_AND_MOVE_VT_TO_ANOTHER_WS,
  GET_VARIANCE_REPORT_DATA_V2,
  GET_INWARD_REPORT,
  GET_INWARD_REPORT_WITH_EXIT_TIME,
  GET_AVAILABLE_MATERIAL_CODES,
  CAPTURE_VEHICLE_WEIGHT,
  GET_CAMERA_WEIGHT_REPORT_DATA,
  GET_WEIGH_BRIDGE_WORK_CENTERS,
  GET_PACK_TYPE,
  GET_PACK_TYPE_FOR_PURCHASE_ORDER_LINE_ITEM,
  CREATE_VEHICLE_TRACKING_LINE_ITEM,
  UPDATE_VEHICLE_TRACKING_LINE_ITEM,
  GET_PURCHASE_ORDER_LINE_ITEMS,
  GET_VEHICLE_TRACKING_LINE_ITEM,
  GET_PURCHASE_ORDERS_AND_LINE_ITEM_DATA,
  GET_STORAGE_LOCATIONS_GROUPED_BY_PLANT,
  CREATE_GRN_FOR_VEHICLE_TRACKING,
  GET_VEHICLE_TRACKING_AWAITING_GRN,
  GET_GRN_FOR_VEHICLE_TRACKING,
  UPDATE_GRN_FOR_VEHICLE_TRACKING,
  UPDATE_FIELD_FOR_VEHICLE_TRACKING,
  GET_PLANTS,
  GET_TARGET_VS_ACTUAL_LOGS,
  GET_TARE_WEIGHT_HISTORY_FOR_VEHICLE_NUMBER,
  GET_WORKFLOW_STAGES_FOR_WORKFLOW,
  RESET_PRINT_DETAILS,
  GET_BUSINESS_PARTNER_DROPDOWN_OPTIONS,
  GET_UNIT_OF_MEASUREMENTS,
  CREATE_DIMENSION,
  GET_DIMENSION_LIST,
  GET_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG,
  GET_DIMENSION_FOR_QUALITY_CHECK_CREATE_LOG,
  CREATE_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG,
  GET_AVAILABLE_QUALITY_CHECKS_FOR_VEHICLE_TRACKING,
  GET_LOG_FOR_QUALITY_CHECKS,
  CREATE_QUALITY_CHECK,
  UPDATE_QUALITY_CHECK_PRODUCT_AND_DIMENSION,
  GET_QUALITY_CHECK_LIST,
  GET_QUALITY_CHECK_PRODUCT_AND_DIMENSION_DETAIL,
  GET_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOGS,
  GET_VAHAN_01_DETAILS,
  CLEAR_VAHAN01_DETAILS,
  GET_VEHICLE_TRACKING_DASHBOARD_DATA,
  GET_WORKFLOW_STAGES_FOR_CURRENT_USER,
  GET_WORKFLOW_STAGES_DATA_FOR_UPCOMING_STAGE_REQUEST,
  GET_UPCOMING_WORKFLOW_STAGE_REQUEST,
  GET_TENANT_PERMISSION,
  GET_VEHICLE_TRACKING_CHANGE_LOG_LIST,
  GET_VEHICLE_TRACKING_CHANGE_LOGS,
  CREATE_VEHICLE_TRACKING_ATTACHMENT,
  GET_PREFILL_SUGGESTIONS_FOR_VEHICLE_TRACKING_LINE_ITEMS,
  GET_VEHICLE_TRACKING_ATTACHMENTS,
  DELETE_VEHICLE_TRACKING_ATTACHMENT,
  GET_TENANT_FEATURE_FLAGS,
  CLEAR_STAGE_DATA,
  GET_ASSIGNED_STAGES_FOR_WORKFLOW_ASSIGNED_TO_USER,
  GET_ASSIGNED_PLANT_FOR_EMPLOYEE,
  GET_OUTWARD_REPORT,
  RESET_VEHICLE_TRACKING_DETAILS,
  RESET_TIMELINE,
  GET_VEHICLE_TRACKING_COMMENTS,
  CREATE_COMMENT_FOR_VEHICLE_TRACKING,
  UPLOAD_VEHICLE_TRACKING_ATTACHMENTS,
  GET_DOCUMENT_LIST_FOR_VEHICLE_TRACKING,
} from 'src/redux/Actions/Type';
const initialState = {
  targetVsActualItems: [],
  timeline: {},
  workflowStagesDataForUpcomingStageRequest: [],
  upcomingWorkflowStageRequest: {},
  poDetailData: {},
  gateEntryDetailFilterPOItemByPONumber: [],
  skipTimeline: [],
  moveToExit: {},
  stationData: null,
  stagesDetails: [],
  barcode: [],
  businessPartnersWithOpenPo: [],
  poItems: [],
  moveToNextStage: {},
  createUpcomingWorkflowStageRequest: {},
  vehicleTrackingDetails: [],
  assignedStages: [],
  workflows: [],
  workflowStagesForVehicleTracking: [],
  targetVsActualConfig: [],
  targetVsActualLogs: {},
  vehicleTrackingReportList: [],
  vehicleTrackingList: [],
  vehicleTrackingWorkflowStagesData: {},
  skipAndMoveVtToAnotherWs: {},
  varianceReportDataV2: [],
  inwardReport: [],
  inwardReportWithExitTime: [],
  availableMaterialCodesForOranisation: [],
  captureVehicleWeightResponse: {},
  cameraWeightReportData: {},
  weighBridgeWorkCenters: [],
  packTypeDataList: [],
  packTypeForPurchaseOrderLineItem: {},
  createVehicleTrackingLineItem: {},
  updateVehicleTrackingLineItem: {},
  poItemList: [],
  vehicleTrackingLineItemList: [],
  purchaseOrderAndLineItemData: [],
  storageLocationsGroupedByPlant: [],
  createGrnForVehicleTrackingResponse: {},
  vehicleTrackingAwaitingGrn: {},
  updateGrnDetailsForVehicleTracking: {},
  updateFieldForVehicleTracking: {},
  plantsData: [],
  targetVsActualLogsList: [],
  tareWeightHistoryForVehicleNumber: null,
  workflowStagesForWorkflow: [],
  workflowStagesForcurrentUser: [],
  businessPartnersDropdown: [],
  unitOfMeasurements: [],
  createDimensionResponse: {},
  createQualityCheckResponse: {},
  updateQualityCheckResponse: {},
  dimensionList: [],
  qualityCheckVehicleTrackingList: [],
  vehicleTrackingLineItemQualityCheckList: {},
  getDimensionForQualityChecklog: {},
  createVehicleTrackingLineItemQualityCheckLog: {},
  availableQualityChecksForVehicleTracking: [],
  getLogDataForQualityCheck: [],
  qualityCheckDetail: {},
  qualityCheckList: [],
  vehicleTrackingLineItemRejectionLogs: [],
  vahan01Details: {},
  vehicleTrackingDashboardData: {},
  tenantPermission: {},
  tenantFeatureFlags: {},
  vehicleTrackingChangeLogData: {},
  // Invoice state
  createAttachment: {},
  allInvoiceSuggestionsForVehicleTracking: {},
  invoiceAttachments: [],
  deleteAttachment: {},
  assignedStagesForWorkflowAssignedToUser: null,
  assignedPlantForEmployee: [],
  outwardReportList: [],
  vehicleTrackingComments: [],
  createCommentForVehicleTracking: {},
  uploadVehicleTrackingAttachments: [],
  documentListForVehicleTracking: [],
};

const VehicleTrackingReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TIMELINE:
      return {
        ...state,
        timeline: payload,
      };
    case RESET_TIMELINE:
      return {
        ...state,
        timeline: {},
      };
    case GET_WORKFLOW_STAGES_DATA_FOR_UPCOMING_STAGE_REQUEST:
      return {
        ...state,
        workflowStagesDataForUpcomingStageRequest: payload,
      };
    case GET_UPCOMING_WORKFLOW_STAGE_REQUEST:
      return {
        ...state,
        upcomingWorkflowStageRequest: payload,
      };
    case GET_VEHICLE_TRACKING_DETAILS:
      return {
        ...state,
        vehicleTrackingDetails: payload,
      };
    case RESET_VEHICLE_TRACKING_DETAILS:
      return {
        ...state,
        vehicleTrackingDetails: [],
      };
    case GET_PO_ITEMS:
      return {
        ...state,
        poItems: payload,
      };
    case GET_TARGET_VS_ACTUAL_FOR_CONFIG:
      return {
        ...state,
        targetVsActualItems: payload,
      };
    case GET_PO_LIST:
      return {
        ...state,
        poDetailData: payload,
      };
    case MOVE_TO_NEXT_STAGE:
      return {
        ...state,
        moveToNextStage: payload,
      };
    case CREATE_UPCOMING_WORKFLOW_STAGE_REQUEST:
      return {
        ...state,
        createUpcomingWorkflowStageRequest: payload,
      };
    case GET_STAGE_DATA:
      return {
        ...state,
        stationData: payload,
      };
    case CLEAR_STAGE_DATA:
      return {
        ...state,
        stationData: null,
      };
    case GET_PURCHASE_ORDERS:
      return {
        ...state,
        purchaseOrderHeader: payload,
      };
    case GET_PURCHASE_ORDERS_AND_LINE_ITEM_DATA:
      return {
        ...state,
        purchaseOrderAndLineItemData: payload,
      };
    case CREATE_VEHICLE_TRACKING:
      return {
        ...state,
        vehicleEntry: payload,
      };
    case GET_BARCODE:
      return {
        ...state,
        barcode: payload,
      };
    case GET_BUSINESS_PARTNER_WITH_OPEN_PO_DROPDOWN_OPTIONS:
      return {
        ...state,
        businessPartnersWithOpenPo: payload,
      };
    case GET_VEHICLE_TRAKING_REPORT_DATA:
      return {
        ...state,
        gateReport: payload,
      };
    case GET_ASSIGNED_STAGES:
      return {
        ...state,
        assignedStages: payload,
      };
    case GET_WORKFLOWS:
      return {
        ...state,
        workflows: payload,
      };
    case GET_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        workflowStagesForVehicleTracking: payload,
      };
    case CLEAR_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        workflowStagesForVehicleTracking: payload,
      };
    case GET_TARGET_VS_ACTUAL_CONFIG_FOR_WORKFLOW_STAGE:
      return {
        ...state,
        targetVsActualConfig: payload,
      };
    case CREATE_TARGET_VS_ACTUAL_LOGS:
      return {
        ...state,
        targetVsActualLogs: payload,
      };
    case GET_VEHICLE_TRACKING_REPORT_LIST:
      return {
        ...state,
        vehicleTrackingReportList: payload,
      };
    case GET_VEHICLE_TRACKING_LIST:
      return {
        ...state,
        vehicleTrackingList: payload,
      };
    case GET_NEXT_AVAILABLE_WORKFLOW_STAGES:
      return {
        ...state,
        vehicleTrackingWorkflowStagesData: payload,
      };
    case SKIP_AND_MOVE_VT_TO_ANOTHER_WS:
      return {
        ...state,
        skipAndMoveVtToAnotherWs: payload,
      };
    case GET_VARIANCE_REPORT_DATA_V2:
      return {
        ...state,
        varianceReportDataV2: payload,
      };
    case GET_INWARD_REPORT:
      return {
        ...state,
        inwardReport: payload,
      };
    case GET_INWARD_REPORT_WITH_EXIT_TIME:
      return {
        ...state,
        inwardReportWithExitTime: payload,
      };
    case GET_AVAILABLE_MATERIAL_CODES:
      return {
        ...state,
        availableMaterialCodesForOranisation: payload,
      };
    case CAPTURE_VEHICLE_WEIGHT:
      return {
        ...state,
        captureVehicleWeightResponse: payload,
      };
    case GET_CAMERA_WEIGHT_REPORT_DATA:
      return {
        ...state,
        cameraWeightReportData: payload,
      };
    case GET_WEIGH_BRIDGE_WORK_CENTERS:
      return {
        ...state,
        weighBridgeWorkCenters: payload,
      };
    case GET_PACK_TYPE:
      return {
        ...state,
        packTypeDataList: payload,
      };
    case GET_PACK_TYPE_FOR_PURCHASE_ORDER_LINE_ITEM:
      return {
        ...state,
        packTypeForPurchaseOrderLineItem: payload,
      };
    case CREATE_VEHICLE_TRACKING_LINE_ITEM:
      return {
        ...state,
        createVehicleTrackingLineItem: payload,
      };
    case UPDATE_VEHICLE_TRACKING_LINE_ITEM:
      return {
        ...state,
        updateVehicleTrackingLineItem: payload,
      };
    case GET_PURCHASE_ORDER_LINE_ITEMS:
      return {
        ...state,
        poItemList: payload,
      };
    case GET_VEHICLE_TRACKING_LINE_ITEM:
      return {
        ...state,
        vehicleTrackingLineItemList: payload,
      };
    case GET_STORAGE_LOCATIONS_GROUPED_BY_PLANT:
      return {
        ...state,
        storageLocationsGroupedByPlant: payload,
      };
    case CREATE_GRN_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        createGrnForVehicleTrackingResponse: payload,
      };
    case GET_VEHICLE_TRACKING_AWAITING_GRN:
      return {
        ...state,
        vehicleTrackingAwaitingGrn: payload,
      };
    case UPDATE_FIELD_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        updateFieldForVehicleTracking: payload,
      };
    case GET_GRN_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        grnForVehicleTracking: payload,
      };
    case UPDATE_GRN_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        updateGrnDetailsForVehicleTracking: payload,
      };
    case GET_PLANTS:
      return {
        ...state,
        plantsData: payload,
      };
    case GET_TARGET_VS_ACTUAL_LOGS:
      return {
        ...state,
        targetVsActualLogsList: payload,
      };
    case GET_TARE_WEIGHT_HISTORY_FOR_VEHICLE_NUMBER:
      return {
        ...state,
        tareWeightHistoryForVehicleNumber: payload,
      };
    case RESET_PRINT_DETAILS:
      return {
        ...state,
        targetVsActualLogsList: [],
      };
    case GET_WORKFLOW_STAGES_FOR_WORKFLOW:
      return {
        ...state,
        workflowStagesForWorkflow: payload,
      };
    case GET_WORKFLOW_STAGES_FOR_CURRENT_USER:
      return {
        ...state,
        workflowStagesForcurrentUser: payload,
      };
    case GET_BUSINESS_PARTNER_DROPDOWN_OPTIONS:
      return {
        ...state,
        businessPartnersDropdown: payload,
      };
    case GET_UNIT_OF_MEASUREMENTS:
      return {
        ...state,
        unitOfMeasurements: payload,
      };
    case CREATE_DIMENSION:
      return {
        ...state,
        createDimensionResponse: payload,
      };
    case CREATE_QUALITY_CHECK:
      return {
        ...state,
        createQualityCheckResponse: payload,
      };
    case UPDATE_QUALITY_CHECK_PRODUCT_AND_DIMENSION:
      return {
        ...state,
        updateQualityCheckResponse: payload,
      };
    case GET_DIMENSION_LIST:
      return {
        ...state,
        dimensionList: payload,
      };
    case GET_AVAILABLE_QUALITY_CHECKS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        availableQualityChecksForVehicleTracking: payload,
      };
    case GET_LOG_FOR_QUALITY_CHECKS:
      return {
        ...state,
        getLogDataForQualityCheck: payload,
      };
    case GET_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG:
      return {
        ...state,
        vehicleTrackingLineItemQualityCheckList: payload,
      };
    case GET_DIMENSION_FOR_QUALITY_CHECK_CREATE_LOG:
      return {
        ...state,
        getDimensionForQualityChecklog: payload,
      };
    case CREATE_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG:
      return {
        ...state,
        createVehicleTrackingLineItemQualityCheckLog: payload,
      };
    case GET_QUALITY_CHECK_LIST:
      return {
        ...state,
        qualityCheckList: payload,
      };
    case GET_QUALITY_CHECK_PRODUCT_AND_DIMENSION_DETAIL:
      return {
        ...state,
        qualityCheckDetail: payload,
      };
    case GET_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOGS:
      return {
        ...state,
        vehicleTrackingLineItemRejectionLogs: payload,
      };
    case GET_VAHAN_01_DETAILS:
      return {
        ...state,
        vahan01Details: payload,
      };
    case CLEAR_VAHAN01_DETAILS:
      return {
        ...state,
        vahan01Details: {},
      };
    case GET_VEHICLE_TRACKING_DASHBOARD_DATA:
      return {
        ...state,
        vehicleTrackingDashboardData: payload,
      };
    case GET_TENANT_PERMISSION:
      return {
        ...state,
        tenantPermission: payload,
      };
    case GET_VEHICLE_TRACKING_CHANGE_LOG_LIST:
      return {
        ...state,
        vehicleTrackingChangeLogData: payload,
      };
    case GET_VEHICLE_TRACKING_CHANGE_LOGS:
      return {
        ...state,
        vehicleTrackingChangedLogData: payload,
      };

    // Invoice cases
    case CREATE_VEHICLE_TRACKING_ATTACHMENT:
      return {
        ...state,
        createAttachment: payload,
      };

    case GET_PREFILL_SUGGESTIONS_FOR_VEHICLE_TRACKING_LINE_ITEMS:
      return {
        ...state,
        allInvoiceSuggestionsForVehicleTracking: payload,
      };

    case GET_VEHICLE_TRACKING_ATTACHMENTS:
      return {
        ...state,
        invoiceAttachments: payload?.attachments || [],
      };

    case DELETE_VEHICLE_TRACKING_ATTACHMENT:
      return {
        ...state,
        deleteAttachment: payload,
      };

    case GET_TENANT_FEATURE_FLAGS:
      return {
        ...state,
        tenantFeatureFlags: payload,
      };
    case GET_ASSIGNED_STAGES_FOR_WORKFLOW_ASSIGNED_TO_USER:
      return {
        ...state,
        assignedStagesForWorkflowAssignedToUser: payload,
      };
    case GET_ASSIGNED_PLANT_FOR_EMPLOYEE:
      return {
        ...state,
        assignedPlantForEmployee: payload,
      };
    case GET_OUTWARD_REPORT:
      return {
        ...state,
        outwardReportList: payload,
      };
    case GET_VEHICLE_TRACKING_COMMENTS:
      return {
        ...state,
        vehicleTrackingComments: payload,
      };
    case CREATE_COMMENT_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        createCommentForVehicleTracking: payload,
      };
    case UPLOAD_VEHICLE_TRACKING_ATTACHMENTS:
      return {
        ...state,
        uploadVehicleTrackingAttachments: payload,
      };
    case GET_DOCUMENT_LIST_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        documentListForVehicleTracking: payload,
      };

    default:
      return state;
  }
};
export default VehicleTrackingReducer;
